<template>
  <ContentPage title="Terms of Use" page="terms" updated="September 15, 2026">
    <p>Welcome to SnapInsta.</p>
    <p>
      By accessing or using SnapInsta, you agree to these Terms of Use. If you do not agree with
      these terms, please do not use the website.
    </p>

    <h2>About SnapInsta</h2>
    <p>
      SnapInsta is an online tool that helps users process publicly accessible Instagram content
      through submitted URLs.
    </p>
    <p>
      SnapInsta is an independent website and is not affiliated with, sponsored by, endorsed by, or
      officially connected with Instagram, Meta Platforms, Inc., or their respective services.
    </p>

    <h2>Use of the Service</h2>
    <p>You may use SnapInsta only for lawful purposes.</p>
    <p>You agree not to use the service to:</p>
    <ul>
      <li>Violate copyright or intellectual property rights</li>
      <li>Download or distribute content without appropriate permission</li>
      <li>Infringe the privacy or other rights of another person</li>
      <li>Attempt to access private or restricted content</li>
      <li>Abuse, disrupt, or interfere with the website</li>
      <li>Use automated systems in a way that places unreasonable load on our infrastructure</li>
      <li>Circumvent technical restrictions or security measures</li>
    </ul>

    <h2>Content Responsibility</h2>
    <p>
      SnapInsta does not own or control the content available through Instagram.
    </p>
    <p>
      Users are responsible for determining whether they have the right or permission to download,
      save, reproduce, modify, or redistribute any content.
    </p>
    <p>
      Downloading content for personal use does not automatically grant ownership or redistribution
      rights.
    </p>
    <p>
      You should respect the copyright, privacy, and other rights of content creators and owners.
    </p>

    <h2>Instagram</h2>
    <p>SnapInsta is not an official Instagram service.</p>
    <p>
      Instagram and its related trademarks, logos, and services belong to their respective owners.
    </p>
    <p>
      Users should also comply with Instagram's applicable terms and policies when using content
      obtained through the service.
    </p>

    <h2>Service Availability</h2>
    <p>
      We try to keep SnapInsta available and functional, but we do not guarantee that the service
      will always be available.
    </p>
    <p>
      The service may be temporarily unavailable because of maintenance, technical problems, network
      issues, third-party changes, or other circumstances beyond our control.
    </p>

    <h2>Third-Party Services</h2>
    <p>
      SnapInsta may rely on third-party infrastructure, hosting providers, security services,
      advertising providers, or other technical services.
    </p>
    <p>
      We are not responsible for the availability or policies of third-party services.
    </p>

    <h2>Disclaimer</h2>
    <p>
      SnapInsta is provided on an "as is" and "as available" basis.
    </p>
    <p>
      We do not guarantee that every URL or piece of content will be processed successfully.
    </p>
    <p>
      We do not guarantee uninterrupted service or that downloaded content will always be available
      in a particular format or quality.
    </p>

    <h2>Changes to These Terms</h2>
    <p>We may update these Terms of Use when necessary.</p>
    <p>
      The updated version will be posted on this page with a revised "Last Updated" date.
    </p>

    <h2>Contact</h2>
    <p>
      If you have questions about these Terms of Use, please contact us through our
      <router-link to="/contact/">Contact Us</router-link> page.
    </p>
  </ContentPage>
</template>

<script>
import ContentPage from '@/components/ContentPage.vue';

export default {
  name: 'TermsOfUse',
  components: {
    ContentPage,
  },
};
</script>
